<template>
  <button @click="exportData" v-bind="$attrs">
    <slot></slot>
  </button>
</template>

<script>
import { mkConfig, generateCsv, download } from 'export-to-csv'

export default {
  name: 'ExportToCsv',
  inheritAttrs: false,
  props: {
    data: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: 'export.csv'
    }
  },
  methods: {
    exportData() {
      const csvConfig = mkConfig({
        filename: this.name.replace('.csv', ''),
        useKeysAsHeaders: this.fields.length === 0,
        columnHeaders: this.fields.length > 0 ? this.fields : undefined
      })
      
      const csv = generateCsv(csvConfig)(this.data)
      download(csvConfig)(csv)
    }
  }
}
</script>